
import { BifrostBackendNestApi, BifrostBackendViaCdnApiV2 } from "../gateways/BifrostBackendApi";

const ProductsTagsProvider = Object.freeze({
	async getProductTags(useApiCdnCaching) {
		return (useApiCdnCaching ? BifrostBackendViaCdnApiV2 : BifrostBackendNestApi).get(`/product-tags`);
	},
	async getProductAssignedTags(useApiCdnCaching) {
		return (useApiCdnCaching ? BifrostBackendViaCdnApiV2 : BifrostBackendNestApi).get(`/product-assigned-tags`);
	}
});

export default ProductsTagsProvider;
